/**
 * Enum representing different comment types.
 * @enum {number}
 */
const CommentType = {
  ClientCancelledBookingClientLogin: 305,
  /**
   * Contact used R2B to create a replace me booking.
   * @type {number}
   */
  ReplaceMeBookingCreate: 11008,
  /**
   * A general comment placed on a booking.
   * @type {number}
   */
  GeneralBookingComment: 200,
  /**
   * Stores information about a candidate running late for a booking.
   * @type {number}
   */
  BookingRunningLate: 201,
  /**
   * Ready2Work - Permanent Availability - Unavailable from Monday to Friday.
   * @type {number}
   */
  R2WUnavailableFromMondayToFriday: 102,
  /**
   * Denotes that a discount has been applied to a booking.
   * @type {number}
   */
  BookingDiscountApplied: 362,
  /**
   * Denotes that an eligible discount has been ignored during the invoicing process.
   * @type {number}
   */
  BookingDiscountIgnored: 363,
  /**
   * A candidate added a new shift record.
   * @type {number}
   */
  BookingShiftRecordAdded: 353,
  /**
   * A client added a new timesheet.
   * @type {number}
   */
  BookingTimesheetAdded: 354,
  /**
   * The booking has been approved by the candidate.
   * @type {number}
   */
  BookingApprovedCandidate: 350,
  /**
   * The booking has been approved by the client.
   * @type {number}
   */
  BookingApprovedClient: 351,
  /**
   * The booking has been disputed by the client.
   * @type {number}
   */
  BookingDisputedClient: 361,
  /**
   * The booking has been disputed by the candidate.
   * @type {number}
   */
  BookingDisputedCandidate: 360,
  /**
   * The booking dispute has been resolved.
   * @type {number}
   */
  BookingDisputeResolved: 364,
  /**
   * The travel plan's status has been updated.
   * @type {number}
   */
  TravelPlanStatusUpdated: 20007,
  /**
   * A phone call has been made from a consultant to the candidate.
   * @type {number}
   */
  PhonecallOutboundCandidate: 112,
  /**
   * A phone call has been made by the candidate to ANZUK.
   * @type {number}
   */
  PhonecallInboundCandidate: 113,
  /**
   * A phone call has been made from a consultant to the candidate.
   * @type {number}
   */
  PhonecallOutboundContact: 114,
  /**
   * A phone call has been made by the candidate to ANZUK.
   * @type {number}
   */
  PhonecallInboundContact: 115,
  /**
   * The booking has been updated.
   * @type {number}
   */
  BookingUpdated: 301,
  /**
   * The booking's status has changed.
   * @type {number}
   */
  BookingStatusChanged: 302,
  /**
   * General comment for invoice/payslip.
   * @type {number}
   */
  InvoicePayslipGeneralComment: 500,
  /**
   * Comment for breakdown of the pay calculator result
   * @type {number}
   */
  PayCalculatorSnapshotComment: 506,
  /**
   * Comment for an unspecified task
   * @type {number}
   */
  TaskGeneralComment: 400,
  /**
   * Comment for a dispute follow up task where no timesheets were submitted
   * @type {number}
   */
  DisputeFollowUpNoTimesheetsSubmitted: 450,
  /**
   * Comment for a dispute follow up task where a candidate modified timesheet was submitted
   * @type {number}
   */
  DisputeFollowUpCandidateModified: 451,
  /**
   * Comment for a dispute follow up task where a candidate stated the booking did not happen
   * @type {number}
   */
  DisputeFollowUpCandidateStatedDidNotHappen: 452,
  /**
   * Comment for a dispute follow up task where a client modified timesheet was submitted
   * @type {number}
   */
  DisputeFollowUpClientModified: 453,
  /**
   * Comment for a dispute follow up task where a client stated the booking did not happen
   * @type {number}
   */
  DisputeFollowUpClientStatedDidNotHappen: 454,
  /**
   * Comment for a dispute follow up task where client and candidate timesheets differ
   * @type {number}
   */
  DisputeFollowUpTimesheetConflict: 455,
  /**
   * Dispute follow up task - The candidate did not submit their timesheet.
   * @type {number}
   */
  DisputeFollowUpCandidateTimesheetNotSubmitted: 456,

  /**
   * Custom Comment Types:
   * These types are used locally and should not be referenced by the backend.
   */

  /**
   * For use with the dispute resolution flyout
   */
  CustomDisputeResolutionHistoryOriginal: -99999901,
  CustomDisputeResolutionHistoryClient: -99999902,
  CustomDisputeResolutionHistoryCandidate: -99999903,
}

export default CommentType
